module.exports = __webpack_public_path__ + "img/sumai.bae74006.9bc2eb47.png";